import useCurrentUser from 'src/admin/users/hooks/useCurrentUser';
import MemoriesEditor from 'src/common/components/memories/MemoriesEditor';

export default function CompanyMemoriesPage() {
  const { isSystemAdmin } = useCurrentUser();

  return (
    <MemoriesEditor
      title="Company memories"
      description="Company memories are shared across all advisors and clients. They are used by the AI to apply company-wide preferences and guidelines to all conversations, documents, and meeting notes."
      emptyText="No company memories saved yet."
      queryKey={['memories', 'company']}
      apiEndpoint="/memories/company"
      canEdit={isSystemAdmin}
    />
  );
}
